module.exports = __webpack_public_path__ + "img/contract-2@2x.e918cf4c.png";